enum API {
	PRIVILEGES = '/api/settings/privilegies'
}

export default API;
